
import Axios from 'axios'
import Qs from 'qs'
import { AppError } from 'src/modules/shared/error/AppError'

const authAxios = Axios.create({
  paramsSerializer: function (params) {
    return Qs.stringify(params, {
      arrayFormat: 'brackets',
      filter: (prefix, value) => {
        if (value instanceof Date) {
          return value.toISOString()
        }

        return value
      },
    })
  },
})

authAxios.interceptors.request.use(
  async function (options) {
    /*
    let jwt = AuthToken.get()
    if (jwt &&) {
      if (jwt.isExpired()) {
        try {
          const response = await Axios.post(`/api/v2/login/refresh-token`, { token: jwt.token })
          jwt = JWT.fromApiResponse(response.data)
          AuthToken.set(jwt, true)
        } catch (error) {}
      }
      const token = jwt.token
      options.headers['Authorization'] = `Bearer ${token}`
    }
      */
    options.headers['Content-Type'] = 'application/json'
    return options
  },
  function (error) {
    return Promise.reject(error)
  }
)

authAxios.interceptors.response.use(
  function (successRes) {
    return successRes
  },
  function (error) {
    if (!error.response) {
      throw new AppError('errors.networkError')
    } else {
      throw error
    }
  }
)

export default authAxios
